import { render, staticRenderFns } from "./FactorReview.vue?vue&type=template&id=9cfdf144&"
import script from "./FactorReview.vue?vue&type=script&lang=js&"
export * from "./FactorReview.vue?vue&type=script&lang=js&"
import style0 from "./FactorReview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FactorReview.vue"
export default component.exports